import http from '../helpers/http';

const HireApplication = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    list: async () => {
      const result = await http.get(`/hire-application`, {
        headers,
      });
      return result.data;
    },
    show: async (id: string, opts?: { includeDrafts?: boolean }) => {
      const result = await http.get(`/hire-application/${id}`, {
        headers,
        params: opts?.includeDrafts ? { includeDrafts: 'true' } : undefined,
      });
      return result.data;
    },
    create: async (body: any) => {
      const result = await http.post(`/hire-application`, body, { headers });
      return result.data;
    },
    delete: async (id: string) => {
      const result = await http.delete(`/hire-application/${id}`, {
        headers,
      });
      return result.data;
    },
    uploadFile: async (userId: string, body: FormData) => {
      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': token,
        },
      };
      const result = await http.patch(`/hire-application/${userId}/document`, body, headers);
      return result.data;
    },
  };
};

export default HireApplication;
